import { render, staticRenderFns } from "./editOnboardedCompanyComponent.vue?vue&type=template&id=d44190ec&"
import script from "./editOnboardedCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./editOnboardedCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports